// Check if the page URL contains "/wide-dress-shoes/"
/*
if (window.location.href.includes("/collections/wide-dress-shoes")) {
  // Find all elements with class ".td-product-card__subtitle" and update innerText
  let productCardSubtitles = document.querySelectorAll('.td-product-card__subtitle');
  productCardSubtitles.forEach(element => {
    element.innerText = "The Original";
  });

} */

  // Find the element with tag "h2" inside ".td-collection-header" and update innerText
/*  let collectionHeaderH2 = document.querySelector('.td-collection-header h2');
  if (collectionHeaderH2) {
    collectionHeaderH2.innerText = "Shoes Available in Wide";
  } */
var topScrollTrigger = document.querySelector('.back-to-top');
topScrollTrigger.addEventListener('click', function (e) {
  document.body.scrollTop = 0; // For Safari

  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});
window.addEventListener('load', function() {
  // add a comma to number strings
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  setTimeout(function() {
    // get the number of reviews
    const badgeText = document.querySelector('.hide-stars .jdgm-prev-badge__text');
    const summaryText = document.querySelector('.jdgm-rev-widg__summary-text');
    
    if (badgeText && summaryText) {
      var numReviews = badgeText.innerHTML;
      var numberMainReviews = summaryText.innerHTML;
      
      // remove commas from the number of reviews
      var numReviewsClean = numReviews.replace(/,/g, "");
      var numMainReviewsClean = numberMainReviews.replace(/,/g, "");
      
      // add a comma to the number of reviews
      var numReviewsComma = numberWithCommas(numReviewsClean);
      var numMainReviewsComma = numberWithCommas(numMainReviewsClean);
      
      // replace the number of reviews with the new number
      badgeText.innerHTML = badgeText.innerHTML.replace(numReviews, numReviewsComma);
      summaryText.innerHTML = summaryText.innerHTML.replace(numberMainReviews, numMainReviewsComma);
    }
  }, 1000);

   var hideStarsElements = document.querySelectorAll('.hide-stars');
  
  hideStarsElements.forEach(function(element) {
    element.addEventListener('click', function() {
      var productCustomReview = document.getElementById('product-custom-review');
      var offsetTop = productCustomReview.offsetTop;
      
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    });
  });
});



/*
$(".product_variant_color .options .option").hover(function(e){
  var thisColor = $(this).attr("data-color");
  $(".product_variant_color .title .title_color").html(thisColor);
  
  var thisImg = $(this).attr("data-img");
  
  $(".product-gallery__item.swiper-slide-active img").attr("src", thisImg);
  $(".product-gallery__item.swiper-slide-active img").attr("srcset", thisImg);
});

$(".product_variant_color").mouseleave(function(e){
  var currentColor = $(".product_variant_color .title").attr("data-current-color");
  $(".product_variant_color .title .title_color").html(currentColor);
  var currentImg = $(".product-gallery__item.swiper-slide-active").attr("data-med");  
  $(".product-gallery__item.swiper-slide-active img").attr("src", currentImg);
  $(".product-gallery__item.swiper-slide-active img").attr("srcset", currentImg);

});
*/
/*
function handleHover(e) {
  var thisColor = $(this).attr("data-color");
  var thisMaterial= $(this).attr("data-material");
  $(".product_variant_color .title .title_color").html(thisColor);
  $(".product_variant_color .title .material-name").html(thisMaterial);
  
  var thisImg = $(this).attr("data-img");
  $(".product-gallery__item.swiper-slide-active img").attr("src", thisImg);
  $(".product-gallery__item.swiper-slide-active img").attr("srcset", thisImg);
}

function handleMouseLeave(e) {
  var currentColor = $(".product_variant_color .title").attr("data-current-color");
  var currentMaterial = $(".product_variant_color .title").attr("data-current-material");
  $(".product_variant_color .title .title_color").html(currentColor);
  $(".product_variant_color .title .material-name").html(currentMaterial);
  var currentImg = $(".product-gallery__item.swiper-slide-active").attr("data-med");  
  $(".product-gallery__item.swiper-slide-active img").attr("src", currentImg);
  $(".product-gallery__item.swiper-slide-active img").attr("srcset", currentImg);
}

// For mouse events
$(".product_variant_color .options .option").hover(handleHover);
$(".product_variant_color").mouseleave(handleMouseLeave);

// For touch events
$(".product_variant_color .options .option").on("touchstart", handleHover);
$(".product_variant_color").on("touchend", handleMouseLeave);
*/

$('.testimonial-quotes-slider').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    fade: true,
    asNavFor: '.testimonial-logos-slider'
  });

$('.testimonial-logos-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.testimonial-quotes-slider',
  arrows: true,
  centerMode: true,
  infinite: true,
  dots: true,
  prevArrow: '.base-carousel__arrow--previous',
  nextArrow: '.base-carousel__arrow--next',
  lazyLoad: 'ondemand',
    responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          }
        }
    ]
});


$('.base-carousel__arrow--previous').click(function(){
  $('.testimonial-logos-slider').slick('slickPrev');
})

$('.base-carousel__arrow--next').click(function(){
  $('.testimonial-logos-slider').slick('slickNext');
})


$(".product-testimonial .testimonial-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        arrows: false,
      }
    }
  ],
  asNavFor: '.product-testimonial .testimonial-image-slider',
  fade: true,
  prevArrow: $('.product-testimonial .left-arrow'),
  nextArrow: $('.product-testimonial .right-arrow'),
});


$(".product-testimonial .testimonial-image-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  infinite: true
});

$(".product-testimonial .testimonial-image-slider .slider-item").click(function(e){
  var index = $(this).attr("data-slick-index");
  $(".product-testimonial .testimonial-slider").slick('slickGoTo', index);
});



/* bestseller slider */

$(".bestseller-slide").click(function() {
      window.location = $(this).find("a").attr("href");
      return false;
    });

$('.bestseller-swipper').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '.bestseller-arrow-prev',
  nextArrow: '.bestseller-arrow-next',
  dots: false,
  autoplay: true,
  arrows: true,
  infinite: true,
  loop: true,
  lazyLoad: 'ondemand',
  asNavFor: '.bestseller-thumbs',
    responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '0',
            centerMode: true,
            arrows: true,
            autoplay: true,
            infinite: true,
            cssEase: 'linear'
          }
        }
    ]
});



$(".bestseller-thumbs").slick({
  slidesToShow: 4,
  arrows: false,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
  loop: true,
  centerMode: true,
  cssEase: 'linear',
  asNavFor: '.bestseller-swipper',
  responsive: [
    {
      breakpoint: 530,
      settings: {
        slidesToShow: 3,
      }
    }
]
});

$(".bestseller-thumbs .bestseller-thumbs-slide").click(function(e){
  var index = $(this).attr("data-slick-index");
  $(".bestseller-swipper").slick('slickGoTo', index);
});

// Remove active class from all thumbnail slides
$('.bestseller-thumbs .slick-slide').removeClass('slick-active');

// Set active class to first thumbnail slides
$('.bestseller-thumbs .slick-slide').eq(0).addClass('slick-active');

// On before slide change match active thumbnail to current slide
$('.bestseller-swipper').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide;
  $('.bestseller-thumbs .slick-slide').removeClass('slick-active');
  $('.bestseller-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
});

/*
var Product_thumb = new Swiper('.product__carousel__thumbs', {
  draggable: false,
  shortSwipes: false,
  spaceBetween: 0,
  centeredSlides: false,
  watchSlidesVisibility: false,
  watchSlidesProgress: false,
  rewind: true,
  navigation: {
    prevEl: '.swiper-arrow-prev',
    nextEl: '.swiper-arrow-next'
  },
});
var Product_slides = new Swiper('.product__carousel__items', {
  draggable: false,
  longSwipesRatio: 0.2,
  centeredSlides: true,
  effect: 'fade',
  rewind: true,
  watchSlidesVisibility: false,
  watchSlidesProgress: false,
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    prevEl: '.swiper-arrow-prev',
    nextEl: '.swiper-arrow-next'
  },
  thumbs: {
      swiper: Product_thumb
  },
  on: {
    //reachEnd: () => this.swiper.slideTo(0, 1000),
    slideChangeTransitionStart: function(){
      var img = $(".product__carousel .carousel .product__carousel__image.swiper-slide-active img").attr("src");
      $(".product_variant_color .title").attr("data-current-img", img);
    }
  }
  
});

*/

/* header bar 
$(".header-slider").slick({
  speed: 1e4, 
  autoplay: !0, 
  autoplaySpeed: 0, 
  centerMode: !1, 
  cssEase: "linear", 
  slidesToShow: 1, 
  slidesToScroll: 1, 
  variableWidth: !0, 
  infinite: !0, 
  initialSlide: 1, 
  arrows: !1, 
  buttons: !1 
});
*/
// here used to be the photoswipe code

$('li.product__variants__item.type.disabled').click(function(){


  /*
  setTimeout(function(){
  $('button.product__btn.add-to-cart.btn.btn--full').text('Add to cart');
  },100)
  */
})

